/** 车辆型号管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/base/vehicleInfo';
/**
 * 分页查询车辆型号管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.VehicleInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询车辆型号管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.VehicleInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个车辆型号管理
 *
 * @param id 车辆型号管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.VehicleInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存车辆型号管理
 *
 * @param params 车辆型号管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新车辆型号管理信息
 *
 * @param params 车辆型号管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除车辆型号管理
 *
 * @param id 车辆型号管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除车辆型号管理
 *
 * @param ids 车辆型号管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
